export enum SubscriptionFeatures {
  FeatureExperiences = 'featureExperiences',
  FeatureCollections = 'featureCollections',
  FeatureInlineAnalytics = 'featureInlineAnalytics'
}
